import { render } from "./GeneralList.vue?vue&type=template&id=7474b4f7&scoped=true"
import script from "./GeneralList.vue?vue&type=script&lang=js"
export * from "./GeneralList.vue?vue&type=script&lang=js"

import "./GeneralList.vue?vue&type=style&index=0&id=7474b4f7&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7474b4f7"]])

export default __exports__